var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-breadcrumbs',{staticClass:"px-0",attrs:{"items":[
        { text: 'Home', to: '/', exact: true },
        { text: 'Burials', to: '/burials', exact: true },
        { text: 'New Burial', disabled: true }
    ],"divider":">"}}),_c('h3',[_vm._v("Create Burial")]),_c('BurialCreateForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }